
import { tryHead, cons, sort as sort_1, append, tryFind as tryFind_1, choose, singleton, collect, head, filter, truncate, zip, tryPick, isEmpty, iterate2, forAll2, empty, map, sortBy, item, length } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { comparePrimitives, compareArrays, curry3, uncurry2, createAtom, equals, int32ToString, compare } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { SimpleDesign, SimpleSheet, SimpleConnection, SimpleComponent, CustomComponentType, LoadedComponent, ComponentType, Component__isSame_596CF542, XYPos, ReducedCanvasState, Connection, Component } from "../Common/CommonTypes.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { contains, ofList as ofList_1, ofSeq } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { arrayOutlineOf } from "./ArrayExpand.js";
import { now } from "../fable_modules/fable-library-js.5.13.0/Date.js";
import { empty as empty_1, forAll, map as map_1, toList, tryFind, ofList } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { bindingsOf, ParamExpression, evaluateParamExpression, ParameterDefs, ParamSlot, CompSlotName } from "../Common/ParameterTypes.js";
import { FSharpResult$2, Result_IsOk, Result_ToOption } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { resolveCanvasAtBindings } from "../Common/ComponentSlots.js";
import { instanceBindingExprs } from "../Common/ParameterAnalysis.js";
import { printf, toFail, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { cToInt, pToInt } from "../Common/Ids.js";

export function sortQBy(byFun, ids) {
    let isSorted = true;
    for (let i = 0; i <= (length(ids) - 2); i++) {
        if (compare(byFun(item(i, ids)), byFun(item(i + 1, ids))) > 0) {
            isSorted = false;
        }
    }
    if (isSorted) {
        return ids;
    }
    else {
        return sortBy(byFun, ids, {
            Compare: (x, y) => (compare(x, y) | 0),
        });
    }
}

/**
 * Formats a ConnectionId for logging purposes
 */
export function logConnId(_arg) {
    return int32ToString(_arg);
}

/**
 * Transform the CanvasState into an f# data structure, with layout data removed (for checking electrically significant changes).
 * Components and connections are sorted to make them order-invariant - selecting components alters order.
 */
export function extractReducedState(state_, state__1) {
    const state = [state_, state__1];
    return new ReducedCanvasState([sortQBy((comp_1) => comp_1.Id, map((comp) => {
        if ((((equals(comp.SymbolInfo, undefined) && (comp.H === 0)) && (comp.W === 0)) && (comp.X === 0)) && (comp.Y === 0)) {
            return comp;
        }
        else {
            return new Component(comp.Id, comp.Type, comp.Label, comp.InputPorts, comp.OutputPorts, 0, 0, 0, 0, undefined, comp.SlotInfo);
        }
    }, state[0])), sortQBy((conn_1) => conn_1.Id, map((conn) => {
        if (equals(conn.Vertices, empty())) {
            return conn;
        }
        else {
            return new Connection(conn.Id, conn.Source, conn.Target, empty());
        }
    }, state[1]))]);
}

/**
 * Is circuit (not geometry) the same for two CanvasStates? fast comparison
 */
export function stateIsEqual(cs1_, cs1__1, cs2_, cs2__1) {
    const cs1 = [cs1_, cs1__1];
    const cs2 = [cs2_, cs2__1];
    const conns1 = cs1[1];
    const comps1 = cs1[0];
    const conns2 = cs2[1];
    const comps2 = cs2[0];
    if (((length(comps1) === length(comps2)) && (length(conns1) === length(conns2))) && forAll2((comp, comp_1) => {
        const comp1 = comp;
        const comp2 = comp_1;
        if (((equals(comp1.Id, comp2.Id) && equals(comp1.InputPorts, comp2.InputPorts)) && equals(comp1.OutputPorts, comp2.OutputPorts)) && (comp1.Label === comp2.Label)) {
            return equals(comp1.Type, comp2.Type);
        }
        else {
            return false;
        }
    }, comps1, comps2)) {
        return forAll2((conn, conn_1) => {
            const conn1 = conn;
            const conn2 = conn_1;
            const portsEqual = (p1, p2) => {
                if ((equals(p1.Id, p2.Id) && equals(p1.HostId, p2.HostId)) && equals(p1.PortNumber, p2.PortNumber)) {
                    return equals(p1.PortType, p2.PortType);
                }
                else {
                    return false;
                }
            };
            if (portsEqual(conn1.Source, conn2.Source)) {
                return portsEqual(conn1.Target, conn2.Target);
            }
            else {
                return false;
            }
        }, conns1, conns2);
    }
    else {
        return false;
    }
}

export function stateIsEqualExInputDefault(cs1_, cs1__1, cs2_, cs2__1) {
    const cs1 = [cs1_, cs1__1];
    const cs2 = [cs2_, cs2__1];
    const conns1 = cs1[1];
    const comps1 = cs1[0];
    const conns2 = cs2[1];
    const comps2 = cs2[0];
    if (((length(comps1) === length(comps2)) && (length(conns1) === length(conns2))) && forAll2((comp, comp_1) => {
        const comp1 = comp;
        const comp2 = comp_1;
        let matchResult;
        if (comp1.Type.tag === 0) {
            if (comp2.Type.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                if ((equals(comp1.Id, comp2.Id) && equals(comp1.InputPorts, comp2.InputPorts)) && equals(comp1.OutputPorts, comp2.OutputPorts)) {
                    return comp1.Label === comp2.Label;
                }
                else {
                    return false;
                }
            default:
                if (((equals(comp1.Id, comp2.Id) && equals(comp1.InputPorts, comp2.InputPorts)) && equals(comp1.OutputPorts, comp2.OutputPorts)) && (comp1.Label === comp2.Label)) {
                    return equals(comp1.Type, comp2.Type);
                }
                else {
                    return false;
                }
        }
    }, comps1, comps2)) {
        return forAll2((conn, conn_1) => {
            const conn1 = conn;
            const conn2 = conn_1;
            const portsEqual = (p1, p2) => {
                if ((equals(p1.Id, p2.Id) && equals(p1.HostId, p2.HostId)) && equals(p1.PortNumber, p2.PortNumber)) {
                    return equals(p1.PortType, p2.PortType);
                }
                else {
                    return false;
                }
            };
            if (portsEqual(conn1.Source, conn2.Source)) {
                return portsEqual(conn1.Target, conn2.Target);
            }
            else {
                return false;
            }
        }, conns1, conns2);
    }
    else {
        return false;
    }
}

/**
 * Are two lists of vertices are very similar.
 * 
 * The lengths are compared FIRST, and not after the fold, because two wires of different lengths
 * are not similar however their common prefix compares - and folding them together first was how
 * this came to raise under .NET, where `List.iter2` is defined only for equal lengths, while
 * returning the right answer in the app, where Fable's stopped at the shorter list. `ListPairs`
 * has since settled that difference in favour of stopping, so the order here is about the answer
 * rather than about raising. Two versions of one connection differ in vertex count whenever the
 * wire has been rerouted, which is the ordinary case for a sheet being edited.
 */
export function verticesAreSame(fixedOffset, tolerance, conns1, conns2) {
    const sq = (x) => (x * x);
    if (length(conns1) === length(conns2)) {
        let errSum = 0;
        iterate2((tupledArg, tupledArg_1) => {
            errSum = (((errSum + sq((tupledArg[0] - tupledArg_1[0]) - fixedOffset.X)) + sq((tupledArg[1] - tupledArg_1[1]) - fixedOffset.Y)) + (!equals(tupledArg[2], tupledArg_1[2]) ? tolerance : 0));
        }, conns1, conns2);
        return errSum < tolerance;
    }
    else {
        return false;
    }
}

export let debugChangedConnections = createAtom(empty());

/**
 * Are two lists of connections identical
 * 
 * **A connection with no vertices on one side is not a difference.** Vertices are a record of a
 * route, and a connection can arrive without one: `extractReducedState` strips them, the sheet
 * DSL writes connections with none so that Issie routes them on load, and a `.dgm` need not have
 * come from this version. In each of those the geometry is not being asserted rather than being
 * asserted to differ, and the wire it names is the same wire between the same two ports. Counting
 * it as changed made a sheet whose route is derived rather than stored report unsaved changes from
 * the moment it opened - which is `currentSheetIsOutOfDate`, so it also prompted on close and drove
 * the auto-backup.
 * 
 * Two connections that BOTH carry vertices are compared as before, so an edit that moves a wire is
 * still seen.
 */
export function compareConns(tolerance, conns1, conns2) {
    const connIdA = (conns) => sortQBy((conn) => conn.Id, conns);
    const connsA1 = connIdA(conns1);
    const connsA2 = connIdA(conns2);
    const sameRoute = (connFixedOffset, c1, c2) => {
        if (isEmpty(c1.Vertices) ? true : isEmpty(c2.Vertices)) {
            return true;
        }
        else {
            return verticesAreSame(connFixedOffset, tolerance, c1.Vertices, c2.Vertices);
        }
    };
    let connFixedOffset_1;
    const xy = (tupledArg) => (new XYPos(tupledArg[0], tupledArg[1]));
    const value = new XYPos(0, 0);
    connFixedOffset_1 = defaultArg(tryPick((tupledArg_1) => {
        let left, right;
        const c1_1 = tupledArg_1[0];
        const c2_1 = tupledArg_1[1];
        if (isEmpty(c1_1.Vertices) ? true : isEmpty(c2_1.Vertices)) {
            return undefined;
        }
        else {
            return (left = xy(item(0, c1_1.Vertices)), (right = xy(item(0, c2_1.Vertices)), new XYPos(left.X - right.X, left.Y - right.Y)));
        }
    }, zip(truncate(length(connsA2), connsA1), truncate(length(connsA1), connsA2))), value);
    if (length(connsA1) !== length(connsA2)) {
        return false;
    }
    else if (!forAll2(uncurry2(curry3(sameRoute)(connFixedOffset_1)), connsA1, connsA2)) {
        const lst = map((badConn) => badConn.Id, map((tuple) => tuple[0], filter((tupledArg_2) => !sameRoute(connFixedOffset_1, tupledArg_2[0], tupledArg_2[1]), zip(connsA1, connsA2))));
        debugChangedConnections(lst);
        return false;
    }
    else {
        return true;
    }
}

/**
 * Are two lists of components identical
 */
export function compareComps(tolerance, comps1, comps2) {
    const byId = (comps) => sortQBy((comp) => comp.Id, comps);
    const matchValue = byId(comps1);
    const matchValue_1 = byId(comps2);
    let matchResult, l1_2, l2_2, c1, c1L, c2, c2L;
    if (!isEmpty(matchValue)) {
        if (length(matchValue) !== length(matchValue_1)) {
            matchResult = 1;
            l1_2 = matchValue;
            l2_2 = matchValue_1;
        }
        else if (!isEmpty(matchValue_1)) {
            matchResult = 2;
            c1 = head(matchValue);
            c1L = matchValue;
            c2 = head(matchValue_1);
            c2L = matchValue_1;
        }
        else {
            matchResult = 3;
        }
    }
    else if (isEmpty(matchValue_1)) {
        matchResult = 0;
    }
    else if (length(matchValue) !== length(matchValue_1)) {
        matchResult = 1;
        l1_2 = matchValue;
        l2_2 = matchValue_1;
    }
    else {
        matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return false;
        case 2: {
            const dx = c1.X - c2.X;
            const dy = c1.Y - c2.Y;
            if ((Math.pow(dx, 2) + Math.pow(dy, 2)) < tolerance) {
                return forAll2((c1_2, c2_2) => {
                    let c1_1, c2_1, arg0__5, arg0__9;
                    if ((c1_1 = c1_2, (c2_1 = c2_2, (((arg0__5 = ((c1_1.X - c2_1.X) - dx), Math.pow(arg0__5, 2))) + ((arg0__9 = ((c1_1.Y - c2_1.Y) - dy), Math.pow(arg0__9, 2)))) < tolerance))) {
                        return Component__isSame_596CF542(c1_2, c2_2);
                    }
                    else {
                        return false;
                    }
                }, c1L, c2L);
            }
            else {
                return false;
            }
        }
        default:
            return false;
    }
}

/**
 * Robust comparison of two schematics. Tolerance determines how similar
 * counts as equal.
 * cannot use equality because float vertices may not be identical
 * use to detemine whether schematic needs to be saved
 * NB for electrical circuit comparison use extractReducedState.
 */
export function compareCanvas(tolerance, _arg2_, _arg2__1, _arg1_, _arg1__1) {
    const _arg = [_arg2_, _arg2__1];
    const _arg_1 = [_arg1_, _arg1__1];
    const compsOk = compareComps(tolerance, _arg[0], _arg_1[0]);
    const connsOk = compareConns(tolerance, _arg[1], _arg_1[1]);
    if (compsOk) {
        return connsOk;
    }
    else {
        return false;
    }
}

/**
 * Compare the name and IOs of two sheets as loadedcomponents
 * For backups, if these change something major has happened
 */
export function compareIOs(ldc1, ldc2) {
    if (ofSeq(ldc1.InputLabels, {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }).Equals(ofSeq(ldc2.InputLabels, {
        Compare: (x_1, y_1) => (compareArrays(x_1, y_1) | 0),
    }))) {
        return ldc1.Name === ldc2.Name;
    }
    else {
        return false;
    }
}

/**
 * Is circuit (not geometry) the same for two LoadedComponents? They must also have the same name
 */
export function loadedComponentIsEqual(ldc1, ldc2) {
    let tupledArg, tupledArg_1;
    if (ldc1 === ldc2) {
        return true;
    }
    else if ((equals(ldc1.InputLabels, ldc2.InputLabels) && equals(ldc1.OutputLabels, ldc2.OutputLabels)) && ((tupledArg = ldc1.CanvasState, (tupledArg_1 = ldc2.CanvasState, stateIsEqual(tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1]))))) {
        return ldc1.Name === ldc2.Name;
    }
    else {
        return false;
    }
}

/**
 * Is circuit (not geometry) the same for two LoadedComponents? They must also have the same name
 */
export function loadedComponentIsEqualExInputDefault(ldc1, ldc2) {
    let tupledArg, tupledArg_1;
    if (ldc1 === ldc2) {
        return true;
    }
    else if ((equals(ldc1.InputLabels, ldc2.InputLabels) && equals(ldc1.OutputLabels, ldc2.OutputLabels)) && ((tupledArg = ldc1.CanvasState, (tupledArg_1 = ldc2.CanvasState, stateIsEqualExInputDefault(tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1]))))) {
        return ldc1.Name === ldc2.Name;
    }
    else {
        return false;
    }
}

/**
 * get sheet I/O labels in correct order based on position of components
 */
export function getOrderedCompLabels(compType, _arg1_, _arg1__1) {
    return map((tuple_1) => tuple_1[1], sortBy((tuple) => tuple[0], collect((comp) => {
        const sortKey = [comp.Y, comp.X];
        const matchValue = comp.Type;
        let matchResult, defaultVal, n, n_1;
        switch (matchValue.tag) {
            case 0: {
                if (compType.tag === 0) {
                    matchResult = 0;
                    defaultVal = matchValue.fields[1];
                    n = matchValue.fields[0];
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            case 1: {
                if (compType.tag === 1) {
                    matchResult = 1;
                    n_1 = matchValue.fields[0];
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            default:
                matchResult = 2;
        }
        switch (matchResult) {
            case 0:
                return singleton([sortKey, [comp.Label, n]]);
            case 1:
                return singleton([sortKey, [comp.Label, n_1]]);
            default:
                return empty();
        }
    }, _arg1_), {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }));
}

/**
 * Extract the labels and bus widths of the inputs and outputs nodes as a signature.
 * Form is inputs,outputs
 * 
 * THE one place that says what a sheet's ports are. On an ordinary sheet they are its Input1 and
 * Output components; on an ARRAY DESIGN SHEET they are derived from its contents and its copy
 * count instead - an Output gives one port per copy, a BusOut one wide one, a loose join an end of
 * a chain - and ArrayExpand.arrayOutlineOf works that out. Every path that asks what a sheet's
 * ports are comes through here, which is what keeps the two kinds of sheet answering one question:
 * loading a sheet, saving one, and CanvasExtractor.signatureOfInstance for an instance of one.
 * 
 * The array settings and the parameter slots are taken rather than read off a LoadedComponent
 * because two callers have a canvas and no sheet: an instance's signature is computed from the
 * child sheet's canvas RESOLVED at that instance's bindings, and the sheet-description DSL builds
 * a canvas before there is a sheet to hold it.
 * 
 * A sheet whose array settings do not work out - a mux over an Array out that is not there, a
 * channel number that will not evaluate - still has ports, and still has to be drawn while it is
 * being fixed. So the problems are dropped here and CanvasStateAnalyser is what reports them and
 * refuses to simulate: see ArrayExpand's note about nothing there throwing.
 */
export function parseDiagramSignatureFor(arrayInfo, paramDefs, canvasState_, canvasState__1) {
    const canvasState = [canvasState_, canvasState__1];
    if (arrayInfo == null) {
        return [getOrderedCompLabels(new ComponentType(/* Input1 */ 0, [0, undefined]), canvasState[0], canvasState[1]), getOrderedCompLabels(new ComponentType(/* Output */ 1, [0]), canvasState[0], canvasState[1])];
    }
    else {
        return arrayOutlineOf(arrayInfo, paramDefs, canvasState[0], canvasState[1])[0];
    }
}

/**
 * A sheet's ports where it is known not to be an array design sheet - which is every canvas that
 * has no sheet behind it to carry array settings. See parseDiagramSignatureFor.
 */
export function parseDiagramSignature(canvasState_, canvasState__1) {
    const canvasState = [canvasState_, canvasState__1];
    return parseDiagramSignatureFor(undefined, undefined, canvasState[0], canvasState[1]);
}

/**
 * A sheet rebuilt from a canvas: everything the canvas says, and everything it cannot say taken
 * from the copy already held.
 * 
 * **THE one place that splits a LoadedComponent's fields between those two.** A sheet is more than
 * its canvas - its array settings say how many copies its components are and give it ports no
 * component on it draws, its parameters give those ports their widths, and being the top sheet
 * decides which design is simulated - and Issie rebuilds sheets from canvases in several places.
 * Three of them dropped all of that and produced an ordinary sheet where an array component had
 * been, with the wrong ports and no expansion. Written once so that there is one place to be
 * right, and Tests/Issie.Tests/SheetIdentity.fs holds the two halves to the whole record.
 * 
 * `existing` is None only where there genuinely is no sheet behind the canvas.
 */
export function sheetFromCanvas(existing, name, canvas_, canvas__1) {
    let option_1, option_3, option_7;
    const canvas = [canvas_, canvas__1];
    const patternInput = parseDiagramSignatureFor((option_1 = existing, (option_1 != null) ? option_1.ArrayInfo : undefined), (option_3 = existing, (option_3 != null) ? option_3.LCParameterSlots : undefined), canvas[0], canvas[1]);
    let LCParameterSlots;
    const option_5 = existing;
    LCParameterSlots = ((option_5 != null) ? option_5.LCParameterSlots : undefined);
    const IsTopSheet = defaultArg((option_7 = existing, (option_7 != null) ? option_7.IsTopSheet : undefined), false);
    let ArrayInfo;
    const option_10 = existing;
    ArrayInfo = ((option_10 != null) ? option_10.ArrayInfo : undefined);
    return new LoadedComponent(name, now(), "", undefined, canvas, patternInput[0], patternInput[1], LCParameterSlots, undefined, false, undefined, IsTopSheet, ArrayInfo);
}

/**
 * extract the fields compared to check circuit equality
 * 
 * No sheet behind the canvas, so nothing to carry: every caller that HAS one should be calling
 * sheetFromCanvas with it.
 */
export function extractLoadedSimulatorComponent(canvas_, canvas__1, name) {
    const canvas = [canvas_, canvas__1];
    return sheetFromCanvas(undefined, name, canvas[0], canvas[1]);
}

/**
 * Put a sheet's parameter slots in order against its canvas, ready to be saved:
 * 
 * - drop slots naming components that are no longer on the sheet. Every parameter slot must
 * name a live component: a slot outliving its component cannot be displayed or edited, and
 * pushing a value into it would throw;
 * - re-point the label an `IO` slot carries at its component's current label. Nothing rewrites
 * that label when the component is renamed, and while no reader depends on it (see
 * ParameterTypes.sameSlotName) it is what the properties pane and the slot table print, so a
 * stale one describes the sheet wrongly.
 */
export function tidyParamSlots(_arg1_, _arg1__1, paramDefs) {
    if (paramDefs != null) {
        const defs = paramDefs;
        const labelOf = ofList(map((comp) => [comp.Id, comp.Label], _arg1_), {
            Compare: (x, y) => (compare(x, y) | 0),
        });
        return new ParameterDefs(defs.DefaultBindings, ofList(choose((tupledArg) => {
            const slot = tupledArg[0];
            const exprSpec = tupledArg[1];
            const matchValue = tryFind(slot.CompId, labelOf);
            if (matchValue != null) {
                if (slot.CompSlot.tag === 1) {
                    const label = matchValue;
                    return [new ParamSlot(slot.CompId, new CompSlotName(/* IO */ 1, [label])), exprSpec];
                }
                else {
                    return [slot, exprSpec];
                }
            }
            else {
                return undefined;
            }
        }, toList(defs.ParamSlots)), {
            Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
        }));
    }
    else {
        return undefined;
    }
}

/**
 * The bindings a sheet is resolved with inside one instance of it.
 * 
 * An instance binding is an expression in the parameters of the sheet the instance SITS ON, so it
 * is evaluated there first and reaches the child sheet as a plain value; every parameter the
 * instance does not bind takes the child's own declared default. This is the same merge
 * GraphMerger.effectiveBindings makes for elaboration, so what is drawn and what is simulated
 * agree. A binding that cannot be evaluated falls back to the default rather than to nothing.
 */
export function effectiveInstanceBindings(childDefaults, parentBindings, instanceBindings) {
    return map_1((name, defExpr) => {
        let option_3, option_1;
        return defaultArg((option_3 = tryFind(name, instanceBindings), (option_3 != null) ? ((option_1 = Result_ToOption(evaluateParamExpression(parentBindings, option_3)), (option_1 != null) ? (new ParamExpression(/* PInt */ 0, [option_1])) : undefined)) : undefined), defExpr);
    }, childDefaults);
}

function signatureIsExact(childDefaults, parentBindings, instanceBindings, effective, slots) {
    if (forAll((name, _arg) => {
        const matchValue = tryFind(name, instanceBindings);
        if (matchValue != null) {
            return Result_IsOk(evaluateParamExpression(parentBindings, matchValue));
        }
        else {
            return true;
        }
    }, childDefaults)) {
        return forAll((_arg_1, exprSpec) => Result_IsOk(evaluateParamExpression(effective, exprSpec.Expression)), slots);
    }
    else {
        return false;
    }
}

/**
 * The signature an instance of `childSheet` has when it binds its parameters as given, and
 * whether its widths are exact. The bindings are read as expressions in `parentBindings` - the
 * parameters of the sheet the instance sits on.
 * Not exact (see signatureIsExact) means some width could not be worked out here, and only the
 * port NAMES may be relied on; the widths are then those the child sheet was saved with.
 * None when the child sheet is not in the project.
 */
export function signatureOfInstanceWithCertainty(ldcs, parentBindings, childSheet, instanceBindings) {
    let childLdc, defs, childDefaults, effective, resolved, tupledArg;
    const option_2 = tryFind_1((ldc) => (ldc.Name === childSheet), ldcs);
    if (option_2 != null) {
        return (childLdc = option_2, (defs = defaultArg(childLdc.LCParameterSlots, new ParameterDefs(empty_1({
            Compare: (x, y) => (compare(x, y) | 0),
        }), empty_1({
            Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
        }))), (childDefaults = bindingsOf(defs.DefaultBindings), (effective = effectiveInstanceBindings(childDefaults, parentBindings, instanceBindings), (resolved = ((tupledArg = childLdc.CanvasState, resolveCanvasAtBindings(effective, defs.ParamSlots, tupledArg[0], tupledArg[1]))), [parseDiagramSignatureFor(childLdc.ArrayInfo, childLdc.LCParameterSlots, resolved[0], resolved[1]), signatureIsExact(childDefaults, parentBindings, instanceBindings, effective, defs.ParamSlots)])))));
    }
    else {
        return undefined;
    }
}

/**
 * The signature an instance of `childSheet` has when it binds its parameters as given.
 * None when the child sheet is not in the project.
 */
export function signatureOfInstance(ldcs, parentBindings, childSheet, instanceBindings) {
    const option_1 = signatureOfInstanceWithCertainty(ldcs, parentBindings, childSheet, instanceBindings);
    if (option_1 != null) {
        return option_1[0];
    }
    else {
        return undefined;
    }
}

/**
 * A custom component instance holding the given port widths, matched to its ports by LABEL.
 * 
 * Widths only. The ORDER of an instance's ports, and which ports it has, are deliberately left
 * alone: an instance whose ports are in a different order from its sheet's is a correct instance
 * (see CustomCompPorts.instanceIsOutOfDate), and a port added to or removed from the sheet is a
 * change the user is asked to confirm rather than one to make behind them. A label the signature
 * says nothing about therefore keeps the width it had.
 */
export function withPortWidths(labelToWidth, cc) {
    const resize = (labels) => map((tupledArg) => {
        const label = tupledArg[0];
        return [label, defaultArg(tryFind(label, labelToWidth), tupledArg[1])];
    }, labels);
    return new CustomComponentType(cc.Name, resize(cc.InputLabels), resize(cc.OutputLabels), cc.Form, cc.ParameterBindings, cc.Description);
}

/**
 * Every custom component instance in the project sized at its OWN bindings.
 * 
 * Resolving a sheet's parameterised slots does not do this. ComponentSlots.setSlotValue writes a
 * CustomCompParam slot into the instance's ParameterBindings, which is all it can reach: the port
 * widths follow from that binding by way of the CHILD sheet, and only signatureOfInstance knows
 * how. So a sheet whose parameter values changed came out of ParameterAnalysis.propagateParameterValues
 * holding instances whose bindings said one width and whose ports still said another.
 * 
 * The open sheet never showed it, because ParameterView.updateComponents pushes its slots through
 * ChangeCustom, which recomputes ports on the way. A CLOSED sheet was written to its file as it
 * stood, and opening it raised the instance-out-of-date error that the whole per-instance
 * signature apparatus exists to avoid.
 * 
 * Pure, and idempotent: it asks what each instance's ports should be and writes that, so running
 * it again finds nothing to change. A sheet whose canvas it rewrites is flagged as needing saving.
 */
export function syncInstancePorts(ldcs) {
    return map((parentLdc) => {
        const defs = defaultArg(parentLdc.LCParameterSlots, new ParameterDefs(empty_1({
            Compare: (x, y) => (compare(x, y) | 0),
        }), empty_1({
            Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
        })));
        const parentBindings = bindingsOf(defs.DefaultBindings);
        const patternInput = parentLdc.CanvasState;
        const comps = patternInput[0];
        const matchValue_1 = map((comp) => {
            let option_2, tupledArg;
            const matchValue = comp.Type;
            if (matchValue.tag === 26) {
                const cc = matchValue.fields[0];
                return defaultArg((option_2 = signatureOfInstance(ldcs, parentBindings, cc.Name, instanceBindingExprs(defs.ParamSlots, comp, cc)), (option_2 != null) ? ((tupledArg = option_2, new Component(comp.Id, new ComponentType(/* Custom */ 26, [withPortWidths(ofList(append(tupledArg[0], tupledArg[1]), {
                    Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                }), cc)]), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo))) : undefined), comp);
            }
            else {
                return comp;
            }
        }, comps);
        if (equals(matchValue_1, comps)) {
            return parentLdc;
        }
        else {
            return new LoadedComponent(parentLdc.Name, parentLdc.TimeStamp, parentLdc.FilePath, parentLdc.WaveInfo, [matchValue_1, patternInput[1]], parentLdc.InputLabels, parentLdc.OutputLabels, parentLdc.LCParameterSlots, parentLdc.Form, true, parentLdc.Description, parentLdc.IsTopSheet, parentLdc.ArrayInfo);
        }
    }, ldcs);
}

/**
 * Returns true if project exists and ldc is electrically identical to same sheet in project
 * canvasState must be the project currently open state.
 */
export function loadedComponentIsSameAsProject(canvasState_, canvasState__1, ldc, p) {
    let tupledArg_2, option_1, ldc1, ldc2, tupledArg, tupledArg_1;
    const canvasState = [canvasState_, canvasState__1];
    const matchValue = ldc.Name;
    let matchResult, name_1, p_2, name_2, p_3;
    if (matchValue === "") {
        matchResult = 0;
    }
    else if (p != null) {
        if (matchValue === p.OpenFileName) {
            matchResult = 1;
            name_1 = matchValue;
            p_2 = p;
        }
        else {
            matchResult = 2;
            name_2 = matchValue;
            p_3 = p;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return false;
        case 1: {
            const patternInput = parseDiagramSignatureFor(ldc.ArrayInfo, ldc.LCParameterSlots, canvasState[0], canvasState[1]);
            const sort = (list) => sort_1(list, {
                Compare: (x, y) => (compare(x, y) | 0),
            });
            if (((tupledArg_2 = ldc.CanvasState, stateIsEqual(canvasState[0], canvasState[1], tupledArg_2[0], tupledArg_2[1]))) && equals(sort(patternInput[0]), sort(ldc.InputLabels))) {
                return equals(sort(patternInput[1]), sort(ldc.OutputLabels));
            }
            else {
                return false;
            }
        }
        default:
            return defaultArg((option_1 = tryFind_1((ldc_1) => (ldc_1.Name === name_2), p_3.LoadedComponents), (option_1 != null) ? ((ldc1 = option_1, (ldc2 = ldc, (equals(ldc1.InputLabels, ldc2.InputLabels) && equals(ldc1.OutputLabels, ldc2.OutputLabels)) && ((tupledArg = ldc1.CanvasState, (tupledArg_1 = ldc2.CanvasState, stateIsEqual(tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1]))))))) : undefined), false);
    }
}

/**
 * Add given name,state to loadedcomponent list as a loaded component (overwriting existing if
 * needed).
 * 
 * **Give it the WHOLE design, the named sheet included.** It replaces that sheet itself, and
 * everything about a sheet that its canvas does not say - its parameters, whether it is the top
 * sheet, and whether it is an ARRAY COMPONENT - can only be carried forward from the copy already
 * in the list. Callers used to filter the sheet out first, which made this lookup dead: while an
 * array component was the sheet being edited, every design built from the model said it was an
 * ordinary sheet, so its ports came out as its drawn IO alone and it was never expanded.
 */
export function addStateToLoadedComponents(openFileName, canvasState_, canvasState__1, loadedComponents) {
    const canvasState = [canvasState_, canvasState__1];
    return cons(sheetFromCanvas(tryFind_1((ldc) => (ldc.Name === openFileName), loadedComponents), openFileName, canvasState[0], canvasState[1]), filter((ldc_2) => (ldc_2.Name !== openFileName), loadedComponents));
}

/**
 * the inverse of addStateToLoadedConponents
 * The loadedComponent list in the result does NOT include diagramName
 * 
 * A sheet that is not there is an Error rather than an exception because one of the callers runs
 * while rendering: the waveform viewer's buttons ask whether the sheet being simulated still
 * builds, and the sheet named by Model.WaveSimSheet can belong to a project that has since been
 * closed. Raising there threw out of the React render, which unmounted the UI and left every
 * later render throwing the same way - nothing short of reloading the app recovered.
 */
export function getStateAndDependencies(diagramName, ldcs) {
    const _arg = tryFind_1((ldc) => (ldc.Name === diagramName), ldcs);
    if (_arg == null) {
        return new FSharpResult$2(/* Error */ 1, [concat("Error - can\'t find ", diagramName, " in dependencies")]);
    }
    else {
        return new FSharpResult$2(/* Ok */ 0, [[diagramName, _arg.CanvasState, filter((ldc_2) => (ldc_2.Name !== diagramName), ldcs)]]);
    }
}

export function simpleSheetOfLoadedComponent(ldc) {
    const patternInput = ldc.CanvasState;
    const comps = patternInput[0];
    const portInfo = ofList(collect((comp) => {
        const entry = (port) => {
            const matchValue = port.PortNumber;
            if (matchValue == null) {
                const arg = pToInt(port.Id) | 0;
                const arg_1 = cToInt(comp.Id) | 0;
                return toFail(printf("simpleSheet: port %d on component %d of %s has no port number"))(arg)(arg_1)(ldc.Name);
            }
            else {
                const n = matchValue | 0;
                return [port.Id, [cToInt(comp.Id), n]];
            }
        };
        return append(map(entry, comp.InputPorts), map(entry, comp.OutputPorts));
    }, comps), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const endpoint = (which, port_1) => {
        const matchValue_1 = tryFind(port_1.Id, portInfo);
        if (matchValue_1 == null) {
            const arg_5 = pToInt(port_1.Id) | 0;
            return toFail(printf("simpleSheet: the %s of a connection on %s names port %d, which no component has"))(which)(ldc.Name)(arg_5);
        }
        else {
            return matchValue_1;
        }
    };
    let patternInput_4;
    const matchValue_2 = ldc.LCParameterSlots;
    if (matchValue_2 == null) {
        patternInput_4 = [empty_1({
            Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
        }), empty_1({
            Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
        })];
    }
    else {
        const defs = matchValue_2;
        patternInput_4 = [defs.DefaultBindings, defs.ParamSlots];
    }
    return new SimpleSheet(ldc.Name, map((comp_1) => (new SimpleComponent(cToInt(comp_1.Id), comp_1.Type, comp_1.Label)), comps), map((conn) => {
        const patternInput_1 = endpoint("source", conn.Source);
        const patternInput_2 = endpoint("target", conn.Target);
        return new SimpleConnection(conn.Id, patternInput_1[0], patternInput_1[1], patternInput_2[0], patternInput_2[1]);
    }, patternInput[1]), patternInput_4[0], patternInput_4[1]);
}

/**
 * The whole design. TopSheet is the flagged top sheet when there is one; otherwise a root of
 * the instantiation forest (a sheet no other sheet instantiates), otherwise the first sheet -
 * the fallback order parameter propagation also uses.
 */
export function simpleDesignOfLoadedComponents(ldcs) {
    let option_5, option_3, option_1;
    const instantiated = ofList_1(collect((ldc) => choose((comp) => {
        const matchValue = comp.Type;
        if (matchValue.tag === 26) {
            return matchValue.fields[0].Name;
        }
        else {
            return undefined;
        }
    }, ldc.CanvasState[0]), ldcs), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const firstByName = (candidates) => tryHead(sortBy((ldc_1) => ldc_1.Name, candidates, {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }));
    return new SimpleDesign(defaultArg((option_5 = ((option_3 = ((option_1 = firstByName(filter((ldc_2) => ldc_2.IsTopSheet, ldcs)), (option_1 != null) ? option_1 : firstByName(filter((ldc_3) => !contains(ldc_3.Name, instantiated), ldcs)))), (option_3 != null) ? option_3 : firstByName(ldcs))), (option_5 != null) ? option_5.Name : undefined), ""), map(simpleSheetOfLoadedComponent, ldcs));
}

